/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React, { Component } from 'react';
import { TEXT_TYPES } from "../../../../../constants/APP_CONSTANTS";
import ModalDialog from "../../../../widgets/ModalDialog/ModalDialog";
import FileUploadModal from "./FileUploadModal";
import config from "../../../../../config";
import urlHelper from "../../../../../_helpers/url.format.server.helper";
import AxiosClient from "../../../../../_helpers/http.helper";
import { FaTrash } from 'react-icons/fa';

export default class FrontMatter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showAddCustomFontMatterModal: false,
            files: [],
            formData: "",
            selectedPrintPageType: TEXT_TYPES.CUSTOM_TOC,
            progressPercentage: 0,
            showProgress: true,
            disableSaveButton: true,
            error: false,
            errorMsg: ""
        };
    }

    addPDFModal = (event) => {
        this.setState({ showProgress: false });
        this.setState({ progressPercentage: 0 });
        this.setState({ showAddCustomFontMatterModal: true });
    };

    closePDFModal = (event) => {
        this.setState({ showAddCustomFontMatterModal: false });
        this.setState({ disableSaveButton: true });
        this.setState({ error: false });
    };

    addFilesToList = (file) => {
        this.setState({ showProgress: true });
        this.progressBarTimeout = setInterval(() => {
            if (this.state.progressPercentage < 90) {
                this.setState({ progressPercentage: this.state.progressPercentage + 5 });
            }
        }, 500);
        this.setState({ disableSaveButton: true });
        const url = urlHelper.formatUrl(
            config.bookBuildService.baseUrl,
            config.bookBuildService.routes.customContentUpload,
            {
                collectionId: this.props.collectionId,
                queryParams: {
                    pageType: this.state.selectedPrintPageType
                }
            }
        );
        if (this.state.formData != "") {
            AxiosClient.post(url, this.state.formData, { "headers": { "content-type": "multipart/form-data" } })
                .then(response => {
                    const result = response.data;
                    this.setState({ showAddCustomFontMatterModal: false });
                    this.setState({ progressPercentage: 100 });
                    if (this.progressBarTimeout) {
                        clearInterval(this.progressBarTimeout);
                    }
                    this.props.getPdfLinks();
                })
                .catch(error => {
                    console.log("Error ", error);
                    if (this.progressBarTimeout) {
                        clearInterval(this.progressBarTimeout);
                    }
                    this.setState({ showProgress: false });
                    this.setState({ error: true });
                    let errorMsg = "{Error occurred while uploading content}";
                    if(error.response){
                        errorMsg = error.response.data.message;
                    }
                    var errorModifiedMsg = errorMsg.substring( errorMsg.indexOf( '{' ) + 1, errorMsg.indexOf( '}' ) );
                    this.setState({ errorMsg: errorModifiedMsg });
                });
        }
    };

    removeFilesFromList = (event) => {
        const url = urlHelper.formatUrl(
            config.bookBuildService.baseUrl,
            config.bookBuildService.routes.customContentDelete,
            {
                collectionId: this.props.collectionId,
                queryParams: {
                    printPageTypeId: event.currentTarget.id
                }
            }
        );
        AxiosClient.delete(url, "")
            .then(response => {
                const result = response.data;
            })
            .catch(error => {
                console.log("Error ", error);
            });

        setTimeout(this.props.getPdfLinks, 2000);
    };

    onDrop = (file) => {
        this.setState(prevState => ({
            files: [...prevState.files, file]
        }));
        const formData = new FormData();
        formData.append('file', file);
        this.setState({ formData: formData });
        this.setState({ disableSaveButton: false });
        this.setState({ error: false });
    };

    handleSelectOnChange = (selectedPrintPageType) => {
        this.setState({
            selectedPrintPageType: selectedPrintPageType
        });
    };

    render() {
        const rows = this.props.pdfs.map((data, index) => 
            <div key={index} className="pe-row fontMatterRow">
                <div className='row-key pe-col-1' >
                    {index + 1}
                </div>
                <div className='row-key pe-col-3' >
                    {data.printPageType}
                </div>
                <div className='pe-col-6'>
                    {data.contentSource === TEXT_TYPES.CONTENT_SOURCE_CUSTOM ? <a href={data.contentUrl} target="_blank">File</a> : TEXT_TYPES.FILE_STATUS_SYSTEM}
                </div>
                <div className='pe-col-2'>
                    {data.contentSource === TEXT_TYPES.CONTENT_SOURCE_CUSTOM ? <button id={data.id} name={data.printPageType} onClick={this.removeFilesFromList}><FaTrash /></button> : TEXT_TYPES.FILE_STATUS_LOCKED}
                </div>
            </div>
        );
        return (
            <div className="pe-row fontmatter-edit-container">
                <div className="font-matter-page">
                    <div className="font-matter">
                        <label className="pe-title--small">Front Matter</label>
                        <div>
                            {!this.props.viewOnlyFrontmatter && <a onClick={() => { this.addPDFModal(true); }} className="add-link"> + Add PDF</a> }
                            <div>
                                <br></br>
                                <div className="pe-col-12 display-table" >
                                    <div className="column pe-col-1">
                                        <b> {TEXT_TYPES.ORDER} </b>
                                    </div>
                                    <div className="column pe-col-3">
                                        <b> {TEXT_TYPES.CONTENT_TYPE} </b>
                                    </div>
                                    <div className="column pe-col-8">
                                        <b> {TEXT_TYPES.FILE} </b>
                                    </div>
                                    <div className="pe-col-12 table-body">
                                        <div className="table-content">
                                            {rows}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ModalDialog
                        className="fontmatter-upload-modal"
                        showModal={this.state.showAddCustomFontMatterModal}
                        onSuccess={() => { this.addFilesToList(); }}
                        disableSuccess={this.state.disableSaveButton}
                        onCancel={() => { this.closePDFModal(); }}
                        title={TEXT_TYPES.ADD_CUSTOM_FONTMATTER}
                        showProgress={this.state.showProgress}
                        progressPercentage={this.state.progressPercentage}>
                        <FileUploadModal onDrop={this.onDrop} handleSelectOnChange={this.handleSelectOnChange} error={this.state.error} errorMsg={this.state.errorMsg} />
                    </ModalDialog>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ComponentPageComponents/FrontMatterComponent/FrontMatter.js